module.exports = __webpack_public_path__ + "img/youtube.cf52d1a9.svg";